module.exports = __webpack_public_path__ + "static/img/0.7503af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/0.png
// module id = ICv5
// module chunks = 0